import Vue from "vue";

Vue.component("custom-form", require("./form").default);
Vue.component("custom-input", require("./input").default);
Vue.component("custom-textarea", require("./textArea").default);
Vue.component("custom-combobox", require("./comboBox").default);
Vue.component("custom-select", require("./selectInput").default);
Vue.component("custom-auto-complete", require("./autoComplete").default);
Vue.component("custom-user-search", require("./userSearch").default);
Vue.component("custom-campaign-search", require("./campaignSearch.vue").default);
Vue.component("custom-button", require("./button").default);
